export enum OWNERSHIP_TYPE {
  CURRENTLY_HAVE_A_MORTGAGE = 'buying',
  OWN_HOME_OUTRIGHT = 'own',
  'RENTING/_LEASING' = 'rent',
  LIVING_WITH_FAMILY = 'family',
}

export const PARTIAL_STATES = ['AL', 'CA', 'CO', 'CT', 'DE', 'ID', 'IN', 'OH'];
